var Targets = {
    _blank: '_blank',
    _self: '_self',
    _right: '_right',
    _dialog: '_dialog'
};

export default Targets;